import { lazy } from 'react';
import { getPublicSitePageRobots, isPublicSitePageEnabled } from '@/publicSite/publicSiteConfig';
import type { AppRouteDefinition } from './routes';

const AppFeaturesPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeaturesPage };
});

const PublicFeaturesPage = lazy(async () => {
  const module = await import('../../pages/FeaturesPage');
  return { default: module.FeaturesPage };
});

const PlansPage = lazy(async () => {
  const module = await import('../../pages/PlansPage');
  return { default: module.PlansPage };
});

export const publicSiteRouteDefinitions: AppRouteDefinition[] = [
  {
    key: 'public-features',
    path: '/features',
    enabled: isPublicSitePageEnabled('features'),
    title: 'FlowQA Features | Operational Memory For Test Execution',
    description:
      'FlowQA helps teams preserve CI test results, compare recurring failures, track flaky tests, and drill from release questions into runs, suites, and tests.',
    metadata: {
      canonicalPath: '/features',
      imageAlt: 'FlowQA test result visibility and QA reporting',
      imagePath: '/logo.png',
      robots: getPublicSitePageRobots(),
      twitterCard: 'summary',
    },
    element: ({ session }) => (session ? <AppFeaturesPage /> : <PublicFeaturesPage />),
  },
  {
    key: 'plans',
    path: '/plans',
    enabled: isPublicSitePageEnabled('plans'),
    title: 'FlowQA Plans | Test Run History And QA Reporting',
    description:
      'Compare FlowQA Free, Solo, and Team plans for CI test result history, JUnit uploads, Playwright visibility, run capacity, retention, and QA reporting.',
    metadata: {
      canonicalPath: '/plans',
      imageAlt: 'FlowQA plans for QA reporting and test run history',
      imagePath: '/logo.png',
      robots: getPublicSitePageRobots(),
      twitterCard: 'summary',
    },
    element: () => <PlansPage />,
  },
];
